
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";

export default {
  components: { VueSlickCarousel },
  data() {
    return {
      options: [
        {
          name: "image",
          label: this.$t("label.image"),
          type: "image",
          size: "1248x614",
        },
        {
          name: "title",
          label: this.$t("label.title"),
          type: "text",
        },
        {
          name: "description",
          label: this.$t("label.description"),
          type: "tipTap",
        },
        {
          name: "link1",
          label: this.$t("label.link"),
          type: "link",
        },
        {
          name: "link2",
          label: this.$t("label.link"),
          type: "link",
        },
      ],

      optionsSocial: [
        {
          name: "icon",
          label: this.$t("label.icon"),
          type: "image",
          size: "24x24",
        },
        {
          name: "link",
          label: this.$t("label.link"),
          type: "link",
        },
      ],

      settings: {
        infinite: true,
        arrows: false,
        autoplay: true,
        dots: true,
        fade: true,
        slidesToShow: 1,
        speed: 1000,
        autoplaySpeed: 2000,
      },
    };
  },
};
